import AtSymbolIcon from '@heroicons/react/outline/AtSymbolIcon'
import CogIcon from '@heroicons/react/outline/CogIcon'
import ViewGridIcon from '@heroicons/react/outline/ViewGridIcon'

import { Card } from '@tribeplatform/react-ui-kit/Card'

import { MemberOnboardingStep } from './Step'

const steps = [
  {
    order: 30,
    title: 'Define structure',
    id: 'create-space',
    description: 'Create collections and spaces',
    icon: ViewGridIcon,
    completed: true,
    button: {
      cta: 'Create space',
      completed: 'Created',
      variant: 'outline',
      action: () => undefined,
    },
  },
  {
    order: 10,
    id: 'confirm-email',
    title: 'Confirm your email',
    description: 'Verify your identity.',
    icon: AtSymbolIcon,
    completed: false,
    button: {
      cta: 'Confirm',
      completed: 'Confirmed',
      variant: 'primary',
      action: () => undefined,
    },
  },
  {
    order: 20,
    title: 'Upload your logo',
    id: 'upload-logo',
    description: 'Upload community logo and set access level.',
    icon: CogIcon,
    completed: false,
    button: {
      cta: 'Setup',
      completed: 'Done',
      variant: 'outline',
      action: () => undefined,
    },
  },
]

export const MemberOnboardingPlaceholder = () => {
  return (
    <Card className="overflow-hidden">
      <Card.Header
        title="Member Onboarding"
        description="This is a preview of what actions new members are encouraged to take when they join the community."
      />
      <div className="pt-3 pb-6 relative w-full overflow-x-auto flex pr-6">
        {steps.map(step => (
          <MemberOnboardingStep step={step} key={step.title} />
        ))}
      </div>
    </Card>
  )
}
